import {useState} from "react";
import {useAuth} from "../../Context/AuthContext";

export default function AdminNavigation({ children,setActiveView }) {
    const { user, logout } = useAuth();
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const fullName = user?.user_metadata?.full_name || "Admin";

    return (
        <div className="relative">
            {/* Mobile Menu Button */}
            <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                className="fixed top-4 left-4 z-50 lg:hidden bg-orange-600 hover:bg-orange-700 text-white p-2 rounded-lg transition duration-300"
            >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
            </button>

            {/* Sidebar */}
            <div className={`fixed top-0 left-0 h-full w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out z-40 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}>
                {/* User Info */}
                <div className="p-6 border-b border-neutral-200">
                    <div className="flex items-center space-x-3">
                        <img loading="lazy"  src="https://placehold.co/48x48" alt="User Avatar" className="w-12 h-12 rounded-full" />
                        <div>
                            <h3 className="text-lg font-semibold text-neutral-800">{fullName}</h3>
                            <p className="text-sm text-neutral-600">Administrator</p>
                        </div>
                    </div>
                </div>

                {/* Navigation Items */}
                <nav className="flex-1 p-4">
                    <ul className="space-y-2">
                        <li>
                            <button onClick={() => setActiveView("statistics")} className="w-full bg-orange-50 flex items-center px-4 py-3 text-neutral-700 hover:bg-orange-600 hover:text-white rounded-lg transition duration-300 group">
                                <svg className="w-5 h-5 mr-3 text-neutral-600 group-hover:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zM9 19V9a2 2 0 012-2h2a2 2 0 012 2v10"></path>
                                </svg>
                                <span className="font-medium">Statistics</span>
                            </button>
                        </li>

                        <li>
                            <button onClick={() => setActiveView("messages")} className="w-full flex bg-orange-50 items-center px-4 py-3 text-neutral-700 hover:bg-orange-600 hover:text-white rounded-lg transition duration-300 group">
                                <svg className="w-5 h-5 mr-3 text-neutral-600 group-hover:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path>
                                </svg>
                                <span className="font-medium">Messages</span>

                            </button>
                        </li>
                        <li>
                            <button onClick={() => setActiveView("bloglist")} className="w-full flex bg-orange-50 items-center px-4 py-3 text-neutral-700 hover:bg-orange-600 hover:text-white rounded-lg transition duration-300 group">
                                <svg className="w-5 h-5 mr-3 text-neutral-600 group-hover:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 8h10v4H7V8zM7 16h10M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                                </svg>
                                <span className="font-medium">Blogs</span>
                            </button>
                        </li>
                    </ul>
                </nav>

                {/* Logout */}
                <div className="p-4 border-t border-neutral-200">
                    <button
                        onClick={logout}
                        className="w-full flex items-center px-4 py-3 text-red-600 hover:bg-red-50 rounded-lg transition duration-300 group "
                    >
                        <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
                        </svg>
                        <span className="font-medium">Logout</span>
                    </button>
                </div>
            </div>

            {/* Overlay for mobile */}
            {sidebarOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-40 z-30 lg:hidden"
                    onClick={() => setSidebarOpen(false)}
                />
            )}

            {/* Main Content */}
            <div className="lg:ml-64 min-h-screen">
                <div className="p-8 pt-20 lg:pt-8">{children}</div>
            </div>
        </div>
    );
}
